/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { Ptw100UnprocessableContentException } from './Ptw100UnprocessableContentException';
import {
    Ptw100UnprocessableContentExceptionFromJSON,
    Ptw100UnprocessableContentExceptionFromJSONTyped,
    Ptw100UnprocessableContentExceptionToJSON,
} from './Ptw100UnprocessableContentException';

/**
 * 
 * @export
 * @interface ErrorResponseOfPtw100UnprocessableContentException
 */
export interface ErrorResponseOfPtw100UnprocessableContentException {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponseOfPtw100UnprocessableContentException
     */
    readonly httpStatusCode?: number;
    /**
     * 
     * @type {Ptw100UnprocessableContentException}
     * @memberof ErrorResponseOfPtw100UnprocessableContentException
     */
    exception: Ptw100UnprocessableContentException;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseOfPtw100UnprocessableContentException
     */
    $type?: ErrorResponseOfPtw100UnprocessableContentExceptionTypeEnum;
}


/**
 * @export
 */
export const ErrorResponseOfPtw100UnprocessableContentExceptionTypeEnum = {
    PtwPtw100WebSharedModelsErrorResponseErrorResponse1PtwPtw100AppZeroCoreSharedExceptionsPtw100UnprocessableContentExceptionPtwPtw100AppZeroCoreSharedPtwPtw100WebShared: 'Ptw.Ptw100.Web.Shared.Models.ErrorResponse.ErrorResponse`1[[Ptw.Ptw100.AppZero.Core.Shared.Exceptions.Ptw100UnprocessableContentException, Ptw.Ptw100.AppZero.Core.Shared]], Ptw.Ptw100.Web.Shared'
} as const;
export type ErrorResponseOfPtw100UnprocessableContentExceptionTypeEnum = typeof ErrorResponseOfPtw100UnprocessableContentExceptionTypeEnum[keyof typeof ErrorResponseOfPtw100UnprocessableContentExceptionTypeEnum];



/**
 * Check if a given object implements the ErrorResponseOfPtw100UnprocessableContentException interface.
 */
export function instanceOfErrorResponseOfPtw100UnprocessableContentException(value?: unknown): value is ErrorResponseOfPtw100UnprocessableContentException {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ErrorResponseOfPtw100UnprocessableContentExceptionTypeEnum)[0];
}

export function ErrorResponseOfPtw100UnprocessableContentExceptionFromJSON(json: any): ErrorResponseOfPtw100UnprocessableContentException {
    return ErrorResponseOfPtw100UnprocessableContentExceptionFromJSONTyped(json, false);
}

export function ErrorResponseOfPtw100UnprocessableContentExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorResponseOfPtw100UnprocessableContentException {
    if (json == null) {
        return json;
    }
    return {
        
        'httpStatusCode': json['httpStatusCode'] == null ? undefined : json['httpStatusCode'],
        'exception': Ptw100UnprocessableContentExceptionFromJSON(json['exception']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ErrorResponseOfPtw100UnprocessableContentExceptionToJSON(value?: Omit<ErrorResponseOfPtw100UnprocessableContentException, 'httpStatusCode'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'exception': Ptw100UnprocessableContentExceptionToJSON(value['exception']),
        '$type': value['$type'],
    });
}

